import React, { useState } from "react";
import {
	Modal,
	ModalBody,
	FormGroup,
	Label,
	Button,
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,
} from "reactstrap";
import Select from "react-select";
import { customStyles } from "pages/app-views/indicadores/Form";
import { SignOut } from "@phosphor-icons/react";

const TransferAndDeactivateModal = ({
	isOpen,
	toggle,
	userIdDesativate,
	handleDesactivate,
	usuariosList,
}) => {
	const [userIdTransferIndicators, setUserIdTransferIndicators] =
		useState(null);
	const [userIdTransferActionPlans, setUserIdTransferActionPlans] =
		useState(null);
	const [
		userIdTransferActionPlansApprover,
		setUserIdTransferActionPlansApprover,
	] = useState(null);
	const [
		userIdTransferActionPlansObjectives,
		setUserIdTransferActionPlansObjectives,
	] = useState(null);
	const [userIdTransferAta, setUserIdTransferAta] = useState(null);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [formSubmitted, setFormSubmitted] = useState(false);

	const isFormValid = () => {
		return (
			userIdTransferIndicators &&
			userIdTransferActionPlans &&
			userIdTransferActionPlansApprover &&
			userIdTransferActionPlansObjectives &&
			userIdTransferAta
		);
	};

	const handleTransferAndDeactivate = async () => {
		setFormSubmitted(true);
		if (!isFormValid()) {
			return;
		}
		setIsSubmitting(true);
		try {
			await handleDesactivate({
				userIdDesativate,
				indicatorsUserId: userIdTransferIndicators,
				actionPlansUserId: userIdTransferActionPlans,
				actionPlansApproverId: userIdTransferActionPlansApprover,
				actionPlansObjectivesId: userIdTransferActionPlansObjectives,
				ataUserId: userIdTransferAta,
			});
		} catch (error) {
			console.error(error);
		} finally {
			setIsSubmitting(false);
			toggle();
		}
	};

	const getSelectStyles = (hasError) => ({
		control: (provided, state) => ({
			...provided,
			minHeight: "38px",
			height: "38px",
			borderColor: hasError ? "red" : provided.borderColor,
			boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : 0,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 9999,
		}),
	});

	return (
		<Modal
			isOpen={isOpen && userIdDesativate}
			toggle={toggle}
			centered
			size="lg"
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-5">
					<p className="text-muted font-size-16 mb-4 text-center">
						Você está prestes a desativar um usuário. Para qual
						pessoa você deseja transferir os cadastros vinculados a
						ele?
					</p>

					<Row>
						{/* Módulo de Indicadores */}
						<Col md={6}>
							<Card className="mb-3">
								<CardBody>
									<CardTitle tag="h5">
										Módulo de Indicadores
									</CardTitle>
									<FormGroup className="mb-3">
										<Label>
											Responsável:{" "}
											<span className="text-danger">
												*
											</span>
										</Label>
										<Select
											styles={getSelectStyles(
												formSubmitted &&
													!userIdTransferIndicators,
											)}
											placeholder="Selecione o usuário"
											onChange={(selectedOption) =>
												setUserIdTransferIndicators(
													selectedOption?.value ||
														null,
												)
											}
											value={usuariosList.find(
												(option) =>
													option.value ===
													userIdTransferIndicators,
											)}
											options={usuariosList}
										/>
										{formSubmitted &&
											!userIdTransferIndicators && (
												<div className="text-danger">
													Este campo é obrigatório.
												</div>
											)}
									</FormGroup>
								</CardBody>
							</Card>
						</Col>

						{/* Módulo de Atas */}
						<Col md={6}>
							<Card className="mb-3">
								<CardBody>
									<CardTitle tag="h5">
										Módulo de Atas
									</CardTitle>
									<FormGroup className="mb-3">
										<Label>
											Responsável:{" "}
											<span className="text-danger">
												*
											</span>
										</Label>
										<Select
											styles={getSelectStyles(
												formSubmitted &&
													!userIdTransferAta,
											)}
											placeholder="Selecione o usuário"
											onChange={(selectedOption) =>
												setUserIdTransferAta(
													selectedOption?.value ||
														null,
												)
											}
											value={usuariosList.find(
												(option) =>
													option.value ===
													userIdTransferAta,
											)}
											options={usuariosList}
										/>
										{formSubmitted &&
											!userIdTransferAta && (
												<div className="text-danger">
													Este campo é obrigatório.
												</div>
											)}
									</FormGroup>
								</CardBody>
							</Card>
						</Col>
					</Row>

					{/* Módulo de Planos de Ação */}
					<Card className="mb-3">
						<CardBody>
							<CardTitle tag="h5">
								Módulo de Planos de Ação
							</CardTitle>
							<Row>
								<Col md={4}>
									<FormGroup className="mb-3">
										<Label>
											Responsável:{" "}
											<span className="text-danger">
												*
											</span>
										</Label>
										<Select
											styles={getSelectStyles(
												formSubmitted &&
													!userIdTransferActionPlans,
											)}
											placeholder="Selecione o usuário"
											onChange={(selectedOption) =>
												setUserIdTransferActionPlans(
													selectedOption?.value ||
														null,
												)
											}
											value={usuariosList.find(
												(option) =>
													option.value ===
													userIdTransferActionPlans,
											)}
											options={usuariosList}
										/>
										{formSubmitted &&
											!userIdTransferActionPlans && (
												<div className="text-danger">
													Este campo é obrigatório.
												</div>
											)}
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup className="mb-3">
										<Label>
											Aprovador:{" "}
											<span className="text-danger">
												*
											</span>
										</Label>
										<Select
											styles={getSelectStyles(
												formSubmitted &&
													!userIdTransferActionPlansApprover,
											)}
											placeholder="Selecione o usuário"
											onChange={(selectedOption) =>
												setUserIdTransferActionPlansApprover(
													selectedOption?.value ||
														null,
												)
											}
											value={usuariosList.find(
												(option) =>
													option.value ===
													userIdTransferActionPlansApprover,
											)}
											options={usuariosList}
										/>
										{formSubmitted &&
											!userIdTransferActionPlansApprover && (
												<div className="text-danger">
													Este campo é obrigatório.
												</div>
											)}
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup className="mb-3">
										<Label>
											Responsável por objetivos:{" "}
											<span className="text-danger">
												*
											</span>
										</Label>
										<Select
											styles={getSelectStyles(
												formSubmitted &&
													!userIdTransferActionPlansObjectives,
											)}
											placeholder="Selecione o usuário"
											onChange={(selectedOption) =>
												setUserIdTransferActionPlansObjectives(
													selectedOption?.value ||
														null,
												)
											}
											value={usuariosList.find(
												(option) =>
													option.value ===
													userIdTransferActionPlansObjectives,
											)}
											options={usuariosList}
										/>
										{formSubmitted &&
											!userIdTransferActionPlansObjectives && (
												<div className="text-danger">
													Este campo é obrigatório.
												</div>
											)}
									</FormGroup>
								</Col>
							</Row>
						</CardBody>
					</Card>

					<div className="d-flex justify-content-end">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={handleTransferAndDeactivate}
							disabled={isSubmitting || !isFormValid()}
						>
							{isSubmitting
								? "Transferindo..."
								: "Transferir e Inativar"}
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={toggle}
							className="ms-2"
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

export default TransferAndDeactivateModal;
